import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as applicationEffects from './application.effects';
import { applicationFeature } from './application.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(applicationFeature),
    EffectsModule.forFeature([applicationEffects]),
  ],
})
export class ApplicationStateModule {}
